import React, { useState } from "react";
export default function CallOutcomeFields({ label, values = {}, onChange, omitFollowup = false }) {
  const [customFutureRecall, setCustomFutureRecall] = useState(false);
  const [futureMode, setFutureMode] = useState(values.futurePeriod && !values.futureDate ? "period" : "date");
  const field = (name, title, type = "text", required = false) => (
    <label key={name} className="block mb-3">
      <span className="block text-sm font-medium mb-1">
        {title}
        {required ? " *" : ""}
      </span>
      <input
        className="w-full rounded-lg border border-slate-300 bg-white p-2 text-sm"
        name={name}
        type={type}
        required={required}
        value={values[name] || ""}
        onChange={(event) => onChange(name, event.target.value)}
      />
    </label>
  );
  return (
    <>
      {!omitFollowup && ["À rappeler", "Rendez-vous obtenu"].includes(label) && (
        <>
          {label === "Rendez-vous obtenu" &&
            field("due", "Date du rendez-vous", "date", true)}
          {field(
            "time",
            label === "À rappeler"
              ? "Heure du rappel promise"
              : "Heure du rendez-vous",
            "time",
            true,
          )}
          <p className="text-sm text-amber-700">
            La date convenue est conservée. Un conflit avec un jour non ouvré
            sera signalé.
          </p>
        </>
      )}
      {label === "Besoin futur" && (
        <fieldset className="rounded-xl border border-blue-100 bg-slate-50 p-4 mb-4">
          <legend className="px-2 font-semibold text-blue-900">Préparer le prochain échange</legend>
          <p className="mb-3 text-sm text-slate-600">Indiquez quand le client prévoit son besoin, puis choisissez si nécessaire une date de rappel différente.</p>
          <label className="block mb-3"><span className="block text-sm font-medium mb-1">Précision du besoin futur</span>
            <select className="w-full rounded-lg border border-slate-300 bg-white p-2 text-sm" value={futureMode} onChange={event => {
              setFutureMode(event.target.value);
              onChange("futureDate", ""); onChange("futurePeriod", "");
            }}><option value="date">Date connue</option><option value="period">Période approximative</option></select>
          </label>
          {futureMode === "date" ? field("futureDate", "Date estimée du besoin", "date", true) : field("futurePeriod", "Période estimée (ex. début janvier)", "text", true)}
          {!omitFollowup && <>
            <label className="check"><input type="checkbox" checked={customFutureRecall} onChange={event => { setCustomFutureRecall(event.target.checked); onChange("due", ""); }} />Choisir la date de rappel convenue avec le client</label>
            {customFutureRecall && field("due", "Date de rappel convenue", "date", true)}
            {!customFutureRecall && <p className="text-sm text-slate-500">Date connue : rappel avant le besoin selon le délai configuré. Période approximative : rappel dans 30 jours ouvrés.</p>}
          </>}
        </fieldset>
      )}
      {label === "Devis accepté" && (
        <p className="text-sm">
          L’acceptation déclarée doit être vérifiée. Elle ne remplace pas
          une signature.
        </p>
      )}
      {label === "Plaquette envoyée" && (
        <>
          <input type="hidden" name="channel" value="email" />
          {field("sentAt", "Date d’envoi", "date")}
        </>
      )}
      {[
        "Travaille avec un concurrent",
        "Contrat exclusif avec un concurrent",
      ].includes(label) && (
        <>
          {label.startsWith("Contrat exclusif") &&
            field("competitor", "Nom du concurrent", "text", true)}
          {field("renewal", "Fin de contrat connue", "date")}
          <label className="block mb-3">
            Collaboration exclusive
            <select
              name="exclusive"
              value={values.exclusive || ""}
              onChange={(event) => onChange("exclusive", event.target.value)}
              className="w-full rounded-lg border bg-white p-2"
            >
              <option value="">Non connue</option>
              <option value="oui">Oui</option>
              <option value="non">Non</option>
            </select>
          </label>
          {field("satisfaction", "Satisfaction / insatisfaction (si connue)")}
        </>
      )}
      {label === "Tarifs trop élevés" && (
        <>
          {field("competitorPrice", "Tarif concurrent connu (€)", "number")}
          <label className="block mb-3">
            <input
              type="checkbox"
              name="managerTask"
              checked={!!values.managerTask}
              onChange={(event) =>
                onChange("managerTask", event.target.checked)
              }
            />{" "}
            Demander une validation tarifaire au responsable
          </label>
          <p className="text-sm">
            Aucune remise n’est accordée automatiquement.
          </p>
        </>
      )}
      {label === "Refus de collaboration" && (
        <>
          <label className="block mb-3">
            Nature du refus *
            <select
              required
              name="refusalType"
              className="w-full rounded-lg border bg-white p-2"
              value={values.refusalType || ""}
              onChange={(event) => onChange("refusalType", event.target.value)}
            >
              <option value="">Choisir</option>
              <option value="temporaire">Temporaire</option>
              <option value="définitif">Définitif</option>
            </select>
          </label>
          <label className="block mb-3">
            <input
              type="checkbox"
              name="opposition"
              checked={!!values.opposition}
              onChange={(event) => onChange("opposition", event.target.checked)}
            />{" "}
            Opposition explicite à toute nouvelle prospection
          </label>
        </>
      )}
      {[
        "Entreprise en liquidation judiciaire",
        "Entreprise en redressement judiciaire",
      ].includes(label) && (
        <p className="rounded-lg bg-amber-50 p-3 text-sm">
          La situation déclarée sera soumise à vérification. L’historique et les
          documents sont conservés.
        </p>
      )}
    </>
  );
}
